import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Image } from '../../../../../common/image'
import classes from '../../../../index.module.scss'
import CurrentPlanSvg from '../../icon/currentPlan.svg'
import RightArrowSvg from '../../icon/rightArrow.svg'

import { useState } from 'react'
import { PopupContactUs } from '../../../../../common/order/popup/popupContactUs'
import { CUSTOM_PLAN, SUB_TITLE } from '../constants'

export const Title = ({ isActive, colorScheme, data }) => {
  const [isOpenPopupContactUs, setIsOpenPopupContactUs] = useState(false)

  const onClosePopupContactUs = () => {
    setIsOpenPopupContactUs(false)
  }

  const openPopupContactUs = () => {
    setIsOpenPopupContactUs(true)
  }

  return (
    <>
      <div
        className={classes.title}
        style={{ backgroundColor: colorScheme.titleBackground }}
      >
        <div className="flexRow justifyContentBetween">
          <div
            className="fw500"
            style={{
              color: colorScheme.title,
              fontSize: 20,
            }}
          >
            {data?.code}
          </div>
          {isActive ? (
            <div className={classes.imgContainer} style={{ marginRight: -10 }}>
              <Image src={CurrentPlanSvg} className={classes.currentPlanImg} />
              <div
                className={classes.text}
                style={{
                  color: '#FFFFFF',
                  fontSize: 10,
                  transform: 'translate(-50%, -75%)',
                  width: 80,
                }}
              >
                <Translate value="userManagement.upgradeViewPlan.CURRENT_PLAN" />
              </div>
            </div>
          ) : (
            <></>
          )}
          {data?.id === CUSTOM_PLAN.id && (
            <Element
              className={classes.contactUsBtn}
              style={{ backgroundColor: '#C8E3FF' }}
              onClick={openPopupContactUs}
            >
              <Translate value="domesticSearchPreview.CONTACT_US" />
              <Image
                src={RightArrowSvg}
                style={{ width: 5, height: 8, marginLeft: 10 }}
              />
            </Element>
          )}
        </div>
        <div style={{ color: colorScheme.title, fontSize: 14 }}>
          {SUB_TITLE[data?.id] ? (
            <>
              <Translate value={SUB_TITLE[data?.id]} dangerousHTML />
            </>
          ) : (
            <Element style={{ height: 16 }} />
          )}
        </div>
      </div>
      <PopupContactUs
        isOpen={isOpenPopupContactUs}
        onClose={onClosePopupContactUs}
      />
    </>
  )
}
